import Proposal from './Proposal.vue'

export default Proposal
